import { Fragment } from "react";

export default function PageTitle(props){
    if (props?.pageTitle){
        return (
            <Fragment>
                <h1 className='mx-5 mt-5 user-select-none'>
                    <span className='golden-h1-bottom-border'>
                        {props.pageTitle}
                    </span> 
                </h1>  
            </Fragment>
        );
    }
    else {
        return (
            <Fragment>
            </Fragment>
        );
    }

}